import { useState } from "react";
import { Button, Modal } from "react-bootstrap";

const AlertModal = (props) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(props.errorMessage).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <Modal show={props.show} onHide={props.handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{props.modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.modalBody}
                {props.errorMessage && (
                    <div className="mt-3">
                        <div className="d-flex justify-content-between align-items-center mb-1">
                            <small className="text-muted fw-semibold">Error Details</small>
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                onClick={handleCopy}
                            >
                                {copied ? "✓ Copied" : "Copy"}
                            </Button>
                        </div>
                        <pre
                            className="p-2 rounded text-danger"
                            style={{
                                backgroundColor: "#fff5f5",
                                border: "1px solid #f5c2c7",
                                fontSize: "0.8rem",
                                whiteSpace: "pre-wrap",
                                wordBreak: "break-word",
                                margin: 0
                            }}
                        >
                            {props.errorMessage}
                        </pre>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary btn-fill" onClick={props.handleConfirmButton}>
                    {props.confirmButton}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default AlertModal;